var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"slide-upp"}},[(_vm.flash)?_c('div',{staticClass:"flash",class:_vm.state,domProps:{"innerHTML":_vm._s(_vm.flash)}}):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }